import type { SessionType } from '../../../types/weekOverview';
import styles from './InterventionCard.module.css';

interface SessionIconProps {
  sessionType: SessionType;
}

// Inline SVGs rather than qampo-ui-library icons: the library's icon set has
// no person/group glyphs, and these need to inherit the session-type text
// colour via currentColor.
export const SessionIcon = ({ sessionType }: SessionIconProps) => {
  if (sessionType === 'INDIVIDUAL' || sessionType === 'ASSESSMENT') {
    return (
      <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
        <path
          d="M8 7.5C6.067 7.5 4.5 5.933 4.5 4S6.067 0.5 8 0.5s3.5 1.567 3.5 3.5S9.933 7.5 8 7.5zM8 8.5c2.485 0 6.5 1.567 6.5 4v3h-13v-3c0-2.433 4.015-4 6.5-4z"
          fill="currentColor"
        />
      </svg>
    );
  }
  if (sessionType === 'GROUP' || sessionType === 'COURSE') {
    return (
      <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
        <path
          d="M5 6.5a2 2 0 100-4 2 2 0 000 4zm6 0a2 2 0 100-4 2 2 0 000 4zM3 12.5C3 10.5 4.5 9 6 9h-1c-1.5 0-3 1.5-3 3.5V14h2v-1.5zM10 12.5C10 10.5 11.5 9 13 9h-1c-1.5 0-3 1.5-3 3.5V14h2v-1.5zM6 14v-1.5C6 11 7 9.5 8 9.5s2 1.5 2 3V14H6z"
          fill="currentColor"
        />
      </svg>
    );
  }
  return null;
};
